export const horseRacingQuery = {
  term: {
    categoryGroupName: 'HORSE RACING',
  },
};
